import React from 'react';
import {RouteComponentProps} from 'react-router';
import {Typography} from '@material-ui/core';
import './grid.css';
import UnitOverview from './components/UnitOverview/UnitOverview';
import {InputFilterProvider} from './stores/InputFiltering/InputFilteringProvider';
import {OutputModeProvider} from './stores/OutputMode/OutputModeProvider';
import {RelayConfigurationProvider} from './stores/RelayConfiguration/RelayConfigurationProvider';
import {LegacyTelematicsDeviceProvider} from './stores/LegacyTelematicsDevice/LegacyTelematicsDeviceProvider';
import {Branding, BrandingContext} from 'components/BrandingProvider';
import UnitSearch from './components/UnitSearch/UnitSearch';
import {DeviceAccessControlProvider} from './stores/DeviceAccessControl/DeviceAccessControlProvider';
import {AutoRefreshState} from "./components/DeviceState/AutoRefreshState";
import {AccessibilityProvider} from "./stores/AccessibilityProvider/AccessibilityProvider";
import {HelpCenterLink} from './components/HelpCenterLink/HelpCenterLink';
import {FitAppDownloadCard} from './components/FitAppDownloadCard/FitAppDownloadCard';

interface UnitPageRouteProps {
    arg?: string;
}

type Props = RouteComponentProps<UnitPageRouteProps>;

export const Unitlookup: React.FC<Props> = props => {
    const brandingContext: Branding = React.useContext(BrandingContext);
    const hasStartedDeviceLookup = Boolean(props.match.params.arg);

    return (
        <div>
          <div style={{display: 'flex'}}>
            <Typography variant="h5" gutterBottom className="fullWidth">
                {brandingContext.welcome}
            </Typography>
            <HelpCenterLink />
          </div>
              <InputFilterProvider>
                <LegacyTelematicsDeviceProvider>
                  <AccessibilityProvider>
                      <AutoRefreshState />
                      <OutputModeProvider>
                        <RelayConfigurationProvider>
                        <DeviceAccessControlProvider>
                          <UnitSearch/>
                          <FitAppDownloadCard hasStartedDeviceLookup={hasStartedDeviceLookup} />
                          <UnitOverview/>
                        </DeviceAccessControlProvider>
                        </RelayConfigurationProvider>
                      </OutputModeProvider>
                  </AccessibilityProvider>
                </LegacyTelematicsDeviceProvider>
              </InputFilterProvider>
        </div>
    );
};
